(function() {
  var FullPage,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  FullPage = App.loadClass('core::FullPageHandler');

  exports.BaseDialog = (function(superClass) {
    extend(BaseDialog, superClass);

    function BaseDialog() {
      return BaseDialog.__super__.constructor.apply(this, arguments);
    }

    BaseDialog.prototype.init = function() {
      this.activeReportWidth = null;
      this.activeReport = null;
      this.filters = this.parent.sidebar;
      return this.appliedFilters = null;
    };

    BaseDialog.prototype.initFirstReport = function() {
      var active_anchor, sub;
      active_anchor = $(this.dialog).find('ul.nav-tabs li a:visible:first');
      this.defaultSub = active_anchor.data('handler-name');
      sub = this.createSubHandler(this.defaultSub, 'Tab');
      if (sub) {
        sub.init();
        this.activeReport = sub;
      }
      return $(active_anchor).tab('show');
    };

    BaseDialog.prototype.afterLoadLayout = function() {
      var ths, writer;
      this.openDialog();
      ths = this;
      this.msg = this.dialog.find('.message_writer');
      this.dialog.find('.declaration-pdf-button').hide();
      this.initFirstReport();
      this.resize();
      this.dialog.find('.nav-tabs').on('shown', function(e) {
        return e.stopPropagation();
      });
      this.dialog.find('.nav-tabs a').click(function(e) {
        var ref, sub;
        if ($(this).parents('li').hasClass('active')) {
          return false;
        }
        ths.topBuffer = function() {
          return void 0;
        };
        e.preventDefault();
        ths.destroyAllSubHandlers();
        $(this).tab('show');
        sub = ths.createSubHandler($(this).data('handler-name'), 'Tab');
        if (sub) {
          sub.init();
          ths.activeReport = sub;
          if ((sub.hasPrint != null) && sub.hasPrint) {
            ths.dialog.find('.print-btn').show();
          } else {
            ths.dialog.find('.print-btn').hide();
          }
        }
        return ths.dialog.css({
          top: (ref = ths.topBuffer()) != null ? ref : -1
        });
      });
      this.dialog.delegate('.excel-link', 'click', (function(_this) {
        return function(e) {
          var url;
          if (_this.appliedFilters == null) {
            _this.appliedFilters = _this.filters.jsonize();
          }
          url = $(e.currentTarget).data('export-url');
          url = url + '?' + $.param({
            query: ko.toJSON(_this.appliedFilters)
          });
          return window.open(url, '_blank');
        };
      })(this));
      this.dialog.delegate('.excel-btn', 'click', (function(_this) {
        return function() {
          var url;
          if (_this.appliedFilters == null) {
            _this.appliedFilters = _this.filters.jsonize();
          }
          url = _this.activeReport.excelUrl + '?' + $.param({
            query: ko.toJSON(_this.appliedFilters)
          });
          return window.open(url, '_blank');
        };
      })(this));
      this.dialog.delegate('.print-btn', 'click', (function(_this) {
        return function() {
          return ths.activeReport.print();
        };
      })(this));
      writer = this.dialog.find('.message_writer');
      writer.message_writer({
        autoHide: false
      });
      return $(window).unbind('finished_report_load modal_resized').bind('finished_report_load modal_resized', debounce((function(_this) {
        return function(e) {
          return ths.resize();
        };
      })(this)));
    };

    BaseDialog.prototype.resize = function() {
      var element, ref, ths;
      ths = this;
      ths.dialog.find('.modal-body').resizr();
      element = ths.dialog.find('.tab-content');
      element.resizr({
        fudge: -20
      });
      if (((ref = this.activeReport) != null ? ref.afterResize : void 0) != null) {
        return this.activeReport.afterResize();
      }
    };

    BaseDialog.prototype.refreshReport = function() {
      var ref;
      if ((ref = this.activeReport) != null) {
        ref.refreshReport();
      }
      return this.appliedFilters = this.filters.jsonize();
    };

    return BaseDialog;

  })(FullPage);

}).call(this);
